<template>
    <component :is="tag" class="card-subtitle">
        <slot>{{ content }}</slot>
    </component>
</template>

<script>
export default {
    name: "bsCardSubtitle",
    props: {
        tag: {
            type: String,
            default: 'h6'
        },
        content: String
    }
};
</script>